import React, { Component } from 'react';
import {
  Grid,
  Row,
  Col,
  Table,
} from 'react-bootstrap';

import './Section.css';

class Section extends Component {
  render() {
    const {
      sStyle = "default",
    } = this.props;
    const className = `Section-container Section-container-${sStyle}`;

    return (
      <section className={className}>
        <Grid>{this.props.children}</Grid>
      </section>
    );
  }
}

class Title extends Component {
  render() {
    const {
      title,
      subtitle,
    } = this.props;

    return (
      <Row>
        <Col lg={12}>
          <div className="Section-title">{title}</div>
          <div className="Section-subtitle">{subtitle}</div>
        </Col>
      </Row>
    );
  }
}

class Body extends Component {
  render() {
    return (
      <Row className="Section-body">
        <Col xs={10} sm={8} md={7} lg={5}>
          {this.props.children}
        </Col>
      </Row>
    );
  }
}

class SectionGrid extends Component {
  render() {
    const {
      items,
      responsive = true
    } = this.props;
    return (
      <Row className="Section-grid equal-height-row">
        {
          items.map((item, index) => {
            return (<SectionGridItem key={index} item={item} responsive={responsive} />);
          })
        }
      </Row>
    );
  }
}

class SectionGridItem extends Component {
  render() {
    const {
      title = "",
      text,
      icon,
    } = this.props.item;
    const responsive = this.props.responsive;
    const classHeader = "Section-grid-item" + (responsive ? "-r" : "");
    return (
      <Col sm={6} md={4} className="Section-grid-item">
        <div className={`${classHeader}-container`}>
          { title ? <div className={`${classHeader}-title`}>{title}</div> : null }
          <div className={`${classHeader}-content`}>
            <div className={`${classHeader}-icon`}>{icon}</div>
            <div className={`${classHeader}-text`}>{text}</div>
          </div>
        </div>
      </Col>
    );
  }
}

class Gallery extends Component {
  render() {
    return (
      <div className="Section-gallery">
        {this.props.children}
      </div>
    );
  }
}

class Comparison extends Component {
  render() {
    const {
      headers = [],
      rows = [],
    } = this.props;

    return (
      <Table className="Section-comparison" condensed striped>
        <thead>
          <tr>
            { headers.map((header, index) => <th key={index}>{header}</th>) }
          </tr>
        </thead>
        <tbody>
        {
          rows.map((row, index) => {
            return (
              <tr key={index}>
                { row.map((item, index) => <td key={index} className="col-xs-6">{item}</td>) }
              </tr>
            )
          })
        }
        </tbody>
      </Table>
    );
  }
}

export default Section;
export {
  Section,
  Title,
  Body,
  SectionGrid,
  Gallery,
  Comparison,
};




// WEBPACK FOOTER //
// ./src/entries/Static/Section.js